// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1pnhy","empty":"ModalGraph_empty__3h6Ua"};